import type { EntryPoint, EntryPointComponent, PreloadFetchPolicy } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async/js-resource-for-interaction';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type HomeStarredListQuery,
} from './starred-list/__generated__/HomeStarredListQuery.graphql';
import type { RuntimeProps } from './starred-list/types';

type EntryPointParams = {
	cypherQuery: string;
	queryContext: string;
};

const fetchPolicy: PreloadFetchPolicy = 'store-or-network';

export const starredListEntryPoint: EntryPoint<
	EntryPointComponent<
		{
			queryReference: HomeStarredListQuery;
		},
		{},
		RuntimeProps,
		{}
	>,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlassian/home-starred-entrypoint" */ './starred-list/HomeStarredListQuery'
			).then((module) => ({ default: module.HomeStarredListQuery })),
		{ moduleId: 'starredListEntryPoint' },
	),
	getPreloadProps: ({ cypherQuery, queryContext }: EntryPointParams) => ({
		queries: {
			queryReference: {
				parameters,
				variables: {
					cypherQuery,
					queryContext,
					first: 250,
				},
				options: {
					fetchPolicy,
				},
			},
		},
	}),
});
